import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 25 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M12.5 24.492q-2.472 0-4.64-.937a12 12 0 0 1-3.81-2.567 12.3 12.3 0 0 1-2.577-3.808q-.926-2.168-.926-4.64 0-2.474.926-4.642A12.2 12.2 0 0 1 4.05 4.09a12 12 0 0 1 3.808-2.567Q10.028.586 12.5.586t4.64.937a12 12 0 0 1 6.376 6.375q.937 2.169.937 4.641t-.937 4.64a11.994 11.994 0 0 1-6.375 6.375q-2.169.939-4.641.938m-1.312-6.234q.304 0 .55-.14.246-.142.434-.423l5.508-8.683q.105-.176.199-.375a.9.9 0 0 0 .094-.399.77.77 0 0 0-.305-.644 1.06 1.06 0 0 0-.68-.246q-.515 0-.843.539l-5.004 8.039-2.38-3.07q-.222-.294-.433-.399a.96.96 0 0 0-.457-.105.87.87 0 0 0-.668.293.95.95 0 0 0-.27.68q0 .198.07.398.083.188.212.363l2.941 3.61q.235.304.48.433.247.129.552.129"
    }, null, -1)
  ]))]))
}
export default { render: render }